import axios from 'axios';
import { api } from './api';

const tokenPublicStaging = 'Basic NjgwOTI4NjMyMzI3Zjc0ZjNhMzZmNjEyOjYzNGQyN2QwOTI3MWYzMzdiMzlmMTQ1OQ==';
const tokenPublicProd = 'Basic NjgwOTI4NjMyMzI3Zjc0ZjNhMzZmNjEyOjYzNGQyN2QwOTI3MWYzMzdiMzlmMTQ1OQ==';

export interface Extra {}

export interface Choice {
  answer: string;
  label: string;
  grade: number;
  extra: Extra;
}

export interface I18n {}

export interface Extra2 {
  owner: string;
  cost: number;
}

export interface QuizType {
  _id: string;
  type: string;
  title: string;
  question: string;
  grade: number;
  choices: Choice[];
  i18n: I18n;
  techniques: string[];
  select: string;
  feedbacks: any[];
  extra: Extra2;
  created: any;
  updated: any;
  requires: any[];
  action: string;
  log: number;
  fund: number;
  fund_size: number;
  owner_name: string;
}

export async function getQuiz(player: string) {
  const { data } = await api.post<[QuizType]>('/find/quiz_quests', { player });

  return data;
}

export async function getQuestions() {
  const { data } = await api.post(
    '/find/get_questions',
    {},
    {
      headers: {
        Authorization: !!window.location.href.match(/(funifier\.app|netlify\.app|localhost)/gi)
          ? tokenPublicStaging
          : tokenPublicProd,
      },
    },
  );

  return data;
}

export async function getQuestionsPublic() {
  const { data } = await axios.post(
    process.env.REACT_APP_API_URL + '/find/get_questions',
    {},
    {
      headers: {
        Authorization: !!window.location.href.match(/(funifier\.app|netlify\.app|localhost)/gi)
          ? tokenPublicStaging
          : tokenPublicProd,
      },
    },
  );

  return data;
}

export async function getAnswers(player: string) {
  const { data } = await api.post('/find/get_answers', { player });

  return data;
}

export async function verifyPlayer(player: string) {
  const { data } = await api.post(
    '/find/verify_user',
    { player },
    {
      headers: {
        Authorization: !!window.location.href.match(/(funifier\.app|netlify\.app|localhost)/gi)
          ? tokenPublicStaging
          : tokenPublicProd,
      },
    },
  );

  return data[0];
}

export async function verifyPlayerPublic(player: string) {
  const { data } = await axios.post(
    process.env.REACT_APP_API_URL + '/find/verify_user',
    { player },
    {
      headers: {
        Authorization: !!window.location.href.match(/(funifier\.app|netlify\.app|localhost)/gi)
          ? tokenPublicStaging
          : tokenPublicProd,
      },
    },
  );

  return data[0];
}

export async function getQuestionsQuiz(quiz: any) {
  const { data } = await api.post('database/question/aggregate', [
    { $match: { _id: { $in: quiz } } },
    { $sort: { 'extra.order': 1 } },
  ]);

  return data;
}

export async function sendQuestionsQuiz(player: string, answer: string, question: string) {
  const payload = {
    player,
    question: question,
    answer: [answer],
  };

  const { data } = await api.post('question/log?async=false', payload, {
    headers: {
      Authorization: !!window.location.href.match(/(funifier\.app|netlify\.app|localhost)/gi)
        ? tokenPublicStaging
        : tokenPublicProd,
    },
  });

  return data;
}

export async function sendQuestionsQuizPublic(player: string, answer: string, question: string) {
  const payload = {
    player,
    question: question,
    answer: [answer],
  };

  const { data } = await axios.post(process.env.REACT_APP_API_URL + '/question/log?async=false', payload, {
    headers: {
      Authorization: !!window.location.href.match(/(funifier\.app|netlify\.app|localhost)/gi)
        ? tokenPublicStaging
        : tokenPublicProd,
    },
  });

  return data;
}

export async function startQuiz(player: string, quiz: string) {
  const { data } = await api.post('quiz/start', { quiz, player });

  return data;
}

export async function finishQuiz(quiz_log: string) {
  const { data } = await api.post('quiz/finish', { quiz_log });

  return data;
}

export async function getQuizQuestions(quiz: string) {
  const { data } = await api.post<[QuizType]>('find/quiz_questions', { quiz });

  return data;
}

export async function sendQuestions(questions: any) {
  const { data } = await api.post('question/log/bulk', questions);

  return data;
}

export async function verifyQuiz(quiz: string) {
  const { data } = await api.post<any>('find/verify_quiz', { quiz });

  return data;
}
